import { render, staticRenderFns } from "./ModalAdicionarDependentes.vue?vue&type=template&id=23ee1cea&scoped=true"
import script from "./ModalAdicionarDependentes.vue?vue&type=script&lang=js"
export * from "./ModalAdicionarDependentes.vue?vue&type=script&lang=js"
import style0 from "./ModalAdicionarDependentes.vue?vue&type=style&index=0&id=23ee1cea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ee1cea",
  null
  
)

export default component.exports